import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-700">
                <span className="font-heading text-base font-semibold text-accent-300">无</span>
              </span>
              <span className="font-heading text-base font-semibold tracking-wide">无码中文字幕</span>
            </div>
            <p className="mt-4 max-w-[280px] text-[13px] leading-6 text-background-300">
              专注日韩自拍视频的内容分类与在线浏览体验，提供清晰的题材导航、多维筛选与流畅的页面节奏。
            </p>
            <p className="mt-4 inline-flex items-center gap-1.5 rounded-full border border-background-700 px-2.5 py-1 text-[11px] text-accent-300">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-shield-check-line text-xs" />
              </span>
              仅限 18 岁以上成年人浏览
            </p>
          </div>

          <div>
            <h4 className="text-[13px] font-medium uppercase tracking-[0.18em] text-background-400">
              <Link to="/#categories" className="transition-colors hover:text-accent-300">
                内容分类
              </Link>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categories.slice(0, 5).map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/category/${encodeURIComponent(category.slug)}`}
                    className="text-[13px] text-background-300 transition-colors hover:text-accent-300"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[13px] font-medium uppercase tracking-[0.18em] text-background-400">
              <Link to="/about" className="transition-colors hover:text-accent-300">
                网站信息
              </Link>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              <li>
                <Link to="/about" className="text-[13px] text-background-300 transition-colors hover:text-accent-300">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about#legal" className="text-[13px] text-background-300 transition-colors hover:text-accent-300">
                  法律声明与免责声明
                </Link>
              </li>
              <li>
                <Link to="/about#feedback" className="text-[13px] text-background-300 transition-colors hover:text-accent-300">
                  意见反馈
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-[13px] text-background-300 transition-colors hover:text-accent-300">
                  搜索内容
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[13px] font-medium uppercase tracking-[0.18em] text-background-400">
              <Link to="/about#contact" className="transition-colors hover:text-accent-300">
                联系我们
              </Link>
            </h4>
            <a
              href="mailto:hello@wumazhongwen.example"
              className="mt-4 flex items-center gap-2 text-[13px] text-background-300 transition-colors hover:text-accent-300"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-mail-line text-sm" />
              </span>
              hello@wumazhongwen.example
            </a>
            <p className="mt-4 text-[12px] leading-6 text-background-500">
              本站全部内容为虚构示范数据，播放区域仅为界面演示，不提供真实播放资源与下载入口。
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col gap-2 px-4 py-5 text-[12px] text-background-500 md:flex-row md:items-center md:justify-between md:px-8">
          <p>© 2026 无码中文字幕 · 示范站点，全部内容为虚构演示用途</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <Link to="/about#legal" className="transition-colors hover:text-background-200">
              使用条款
            </Link>
            <Link to="/about#legal" className="transition-colors hover:text-background-200">
              隐私说明
            </Link>
            <span>18+ ONLY</span>
          </div>
        </div>
      </div>
    </footer>
  );
}